import { render, staticRenderFns } from "./CopywritingComponents.vue?vue&type=template&id=7eedcd85&scoped=true"
import script from "./CopywritingComponents.vue?vue&type=script&lang=js"
export * from "./CopywritingComponents.vue?vue&type=script&lang=js"
import style0 from "./CopywritingComponents.vue?vue&type=style&index=0&id=7eedcd85&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eedcd85",
  null
  
)

export default component.exports